export const PRIORITY_COUNTRY_CODES = [
  'TH',
  'CN',
  'JP',
  'KR',
  'US',
  'GB',
  'DE',
  'FR',
  'AU',
  'SG',
];

export interface PrioritizableCountry {
  code: string;
  name: string;
}

export const sortCountriesByPriority = <T extends PrioritizableCountry>(
  countries: T[],
): T[] => {
  return [...countries].sort((a, b) => {
    const ai = PRIORITY_COUNTRY_CODES.indexOf(a.code);
    const bi = PRIORITY_COUNTRY_CODES.indexOf(b.code);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
    return a.name.localeCompare(b.name);
  });
};
